{
  "version": 1,
  "asset_id": "f31c1481-8867-4e62-bfc1-09a36ed93ee5",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/f31c1481-8867-4e62-bfc1-09a36ed93ee5/sleeve-hiatal-type-1-second-es-800.webp",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/f31c1481-8867-4e62-bfc1-09a36ed93ee5/sleeve-hiatal-type-1-second-es-800.webp",
  "original_filename": "sleeve-hiatal-type-1-second-es-800.webp",
  "size": 47052,
  "content_type": "image/webp",
  "created_at": "2026-09-26T22:32:08Z"
}
